import { render } from "./SynergySidebar.vue?vue&type=template&id=e4b4dcf4"
import script from "./SynergySidebar.vue?vue&type=script&lang=js"
export * from "./SynergySidebar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Code\\word\\anyRTC\\anyrtc_synergy\\Synergy-Experts\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__